import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import List from './List';
import { SortType } from '../../ColumnHeader';

const PlayersListSortable = props => {
    const { players } = props;
    const [sortParam, setSortParam] = useState('name');
    const [sortType, setSortType] = useState(SortType.ASC);

    const handleSortClick = (sortPrm, selectedSortType) => {
        setSortParam(sortPrm);
        setSortType(selectedSortType);
    };

    return (
        <div className="mt64">
            <Header
                sortParam={sortParam}
                sortType={sortType}
                handleSortClick={handleSortClick}
            />
            <List
                players={players}
                sortParam={sortParam}
                sortType={sortType}
            />
        </div>
    );
};

PlayersListSortable.propTypes = {
    players: PropTypes.instanceOf(Array).isRequired,
};

export default PlayersListSortable;
